export class Post {
    author: string;
    authorImage?:string;
    text: string;
    date: string;
    type: string;
    commentsCount?: number;
    likesCount?: number;
    liked?: boolean;
    photo?: {
        url: string;
        width: number;
        height: number;
    };
    video?: {
        url: string;
        width: number;
        height: number;
    };
    shared?: {
        pid: string;
        uid: string;
    };
    isShared?:boolean;
    mentioned?: {
        [key: string]: {
            type: number;
            username: string;
        };
    };
    $key: string;
}
